import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const concept = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">
        LoRaWAN system for Smart Farming in Rural India
      </Typography>
      Smart farming currently relies on satellite, existing terrestrial or
      mobile network connectivity for gathering data from sensors. The coverage
      over rural farming areas is often patchy and the data charges incurred can
      be significant. LoRaWAN is a cost effective solution for farmers which
      allows for data to be transmitted over long distance.
      <br />
      The benefits include:
      <br />
      > Reduced manpower involved in security, monitoring, fencing and machinery
      through remote asset management.
      <br />> Increased yields as a result of data driven precision farming.
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./LoRaWAN-Overview.png"
          alt="LoRaWAN"
        />
      </div>{" "}
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./LoRa_Why_Range.png"
          alt="LoRaWAN Range"
        />
      </div>{" "}
    </div>
  );
};

export default withStyles(styles)(concept);
